import { styled } from '@mui/material/styles';
import TableContainer from '@mui/material/TableContainer';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export const StyledPaper = styled(Paper)(({ theme }) => ({
    margin: '0 auto',
    maxWidth: '100vw', // Prevents paper from making main page scroll
    boxShadow: theme.shadows[1],
    borderRadius: theme.shape.borderRadius,
    background: theme.palette.background.paper,
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    maxWidth: '100%',
    overflowX: 'auto',
    margin: 0,
    padding: 0,
    background: theme.palette.background.paper,
    '&::-webkit-scrollbar': {
        height: 8,
    },
    '&::-webkit-scrollbar-thumb': {
        background: theme.palette.divider,
        borderRadius: 4,
    },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 180,
    fontSize: 14,
    padding: '12px 16px',
    [theme.breakpoints.down('md')]: {
        fontSize: 13,
        padding: '8px 6px',
        maxWidth: 100,
    },
    '&.MuiTableCell-head': {
        background: theme.palette.grey[100],
        fontWeight: 600,
        fontSize: 15,
        color: theme.palette.grey,
        borderBottom: `2px solid ${theme.palette.primary.main}33`,
    },
}));
export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:hover': {
        backgroundColor: `${theme.palette.action.selected}33`,
    },
    transition: 'background 0.2s',
}));
